var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#E6F6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1339 29.0385L31.9339 30.8163C32.295 31.0441 32.7394 30.7052 32.6339 30.2885L31.8227 27.0996C31.8008 27.0112 31.8043 26.9185 31.8328 26.832C31.8613 26.7455 31.9137 26.6688 31.9839 26.6107L34.495 24.5163C34.8227 24.2441 34.6561 23.6941 34.2283 23.6663L30.9505 23.4552C30.8611 23.45 30.7751 23.4188 30.7031 23.3656C30.6311 23.3123 30.5761 23.2392 30.545 23.1552L29.3227 20.0774C29.2904 19.9885 29.2315 19.9116 29.1539 19.8573C29.0764 19.803 28.9841 19.7739 28.8894 19.7739C28.7948 19.7739 28.7024 19.803 28.6249 19.8573C28.5474 19.9116 28.4884 19.9885 28.4561 20.0774L27.2339 23.1552C27.2027 23.2392 27.1478 23.3123 27.0757 23.3656C27.0037 23.4188 26.9177 23.45 26.8283 23.4552L23.5505 23.6663C23.1227 23.6941 22.9561 24.2441 23.2839 24.5163L25.795 26.6107C25.8652 26.6688 25.9175 26.7455 25.946 26.832C25.9745 26.9185 25.978 27.0112 25.9561 27.0996L25.2061 30.0552C25.0783 30.5552 25.6116 30.9607 26.0394 30.6885L28.645 29.0385C28.718 28.9921 28.8028 28.9674 28.8894 28.9674C28.976 28.9674 29.0608 28.9921 29.1339 29.0385V29.0385Z",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8889 16.6666V12.2221C28.8889 11.2403 28.093 10.4443 27.1111 10.4443L9.33336 10.4443C8.35152 10.4443 7.55558 11.2403 7.55558 12.2221V24.6666C7.55558 25.6484 8.35152 26.4443 9.33336 26.4443L21.3334 26.4443",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3368 26.4443L11.3368 11.3332",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0034 14.2231L28.0034 14.2231",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 17.5562L20 17.5562",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.a705dabc3edd0a470afe390585038e1e.svg";
export { ForwardRef as ReactComponent };